import "core-js/modules/es.array.push.js";
import { showConfirmDialog } from 'vant';
import md5 from 'js-md5';
import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import { mapGetters } from 'vuex';
import cptCmn from '@/mixin/cpt-cmn';
import AttachmentCpt from '@/components/attachment';
import PopupDatePickerCpt from '@/components/date-time/PopupDatePickerCpt';
import { rqtGetAppointment, rqtPutCancleAppointment, rqtPostAppointmentSave } from '@/services/wms/appointment';
// import { rqtPostAttachmentList } from '@/services/common/attachment'
import verificationCodeImg from '@/mixin/verification-code-img';
export default {
  mixins: [cptCmn, verificationCodeImg],
  components: {
    PageNavBackLayoutCpt,
    AttachmentCpt,
    PopupDatePickerCpt
  },
  data() {
    return {
      show: false,
      routeArg: undefined,
      paymentAcc: undefined,
      appointmentId: undefined,
      fItemDataIndex: undefined,
      paymentDate: undefined,
      form: {
        agentId: '',
        customerId: '',
        productId: '',
        openDate: '',
        amount: '',
        validateCode: ''
      },
      btnLoading: false,
      agent: {},
      production: {},
      customer: {},
      appointment: {},
      codeResItems: [{
        title: '风险等级',
        dataIndex: 'riskGrade',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'riskGrade'
      }]
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  mounted() {
    this.init();
    this.handleCodeImg();
  },
  methods: {
    init() {
      let item = this.$route.query && this.$route.query.item;
      this.appointmentId = this.$route.query && this.$route.query.item.appointmentId;
      this.routeArg = this.$route.query && this.$route.query.item;
      if (item) {
        this.initResCodeType(this.codeResItems);
        item = JSON.parse(item);
        rqtGetAppointment(item).then(res => {
          const resData = res.data.data;
          this.agent = resData.agentQueryRecordVo;
          this.production = resData.wmsProductQueryRecordVO;
          this.customer = resData.customerBaseVo;
          this.appointment = resData.appointment;
          this.appointmentId = resData.appointment.id;
          this.paymentDate = this.appointment.paymentDate;
          this.paymentAcc = this.appointment.paymentAcc;
          this.form = resData.appointment;
        }).catch(() => {});
        this.$refs['AttachmentCpt'].showView({
          businessId: item.appointmentId,
          attachmentType: '08'
        });
        /* this.$refs['AttachmentCpt1'].showView({
          businessId: item.appointmentId,
          attachmentType: '10'
        }) */
      }
    },

    onPopupDateTimeSelectClick(dataIndex) {
      this.fItemDataIndex = dataIndex;
      this.$refs['PopupDateTimeCpt'].showView();
    },
    imgUpload() {
      // this.init()
      let item = this.$route.query && this.$route.query.item;
      item = JSON.parse(item);
      this.$refs['AttachmentCpt'].showView({
        businessId: item.appointmentId,
        attachmentType: '08'
      });
      this.$refs.AttachmentCpt.showComponent(this.routeArg);
    },
    onDateTimeSelectedChange(val) {
      this.paymentDate = val;
    },
    //撤销
    onSubmit() {
      showConfirmDialog({
        title: '提示',
        message: '确定这样做嘛？'
      }).then(() => {
        this.btnLoading = true;
        rqtPutCancleAppointment(this.appointment).then(() => {
          this.btnLoading = false;
          this.$message.success('操作成功');
          this.$router.go(-1);
        }).catch(() => {
          this.btnLoading = false;
        });
      }).catch(() => {});
    },
    //保存
    onSave() {
      let SIGN_KEY = 'lvchengcaifu_fang#zhi_!waigua**';
      let md5_key = undefined;
      let str = undefined;
      if (!this.form.openDate) {
        str = SIGN_KEY + this.form.productId + 'null' + this.form.customerId + this.form.amount;
        md5_key = md5(str);
      } else {
        str = SIGN_KEY + this.form.productId + this.form.openDate + this.form.customerId + this.form.amount;
        md5_key = md5(str);
      }
      let param = {
        paymentDate: this.paymentDate,
        paymentAcc: this.paymentAcc,
        paymentType: '02',
        openDate: this.form.openDate,
        customerId: this.form.customerId,
        amount: this.form.amount,
        productId: this.form.productId
      };
      param.id = this.appointmentId;
      param.uuid_key = this.codeUuidKey;
      param.sign = md5_key;
      rqtPostAppointmentSave(param).then(() => {
        this.$message.success('操作成功');
        let that = this;
        setTimeout(() => {
          that.$router.push('/work-wx/appoint/query');
        }, 1500);
      }).catch(err => {
        console.error(err);
      });
    },
    //查看打款凭证
    viewPayment() {
      if (this.appointment.status == '03') {
        let item = this.$route.query && this.$route.query.item;
        item = JSON.parse(item);
        this.$refs['AttachmentCpt'].showView({
          businessId: item.appointmentId,
          attachmentType: '08'
        });
        this.$refs.AttachmentCpt.showComponent(this.routeArg);
        this.$refs.AttachmentCpt.isUpload = false;
        this.$refs.AttachmentCpt.isDelImage = false;
      }
    }
  }
};